export const NOT_AVAILABLE = 'not available'

const trackEvent = (event: Record<string, unknown>): void => {
  if (!window) return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(event)
}

export default trackEvent
